import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface InfoModalData {
  title: string;
  message: string;
  buttonText?: string;
  onClose?: () => void;
  isSuccessMessage?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class InfoModalService {
  private isModalVisibleSubject = new BehaviorSubject<boolean>(false);
  isModalVisible$ = this.isModalVisibleSubject.asObservable();
  
  private modalDataSubject = new BehaviorSubject<InfoModalData | null>(null);
  modalData$ = this.modalDataSubject.asObservable();

  constructor() { }

  show(data: InfoModalData) {
    this.isModalVisibleSubject.next(true);
    this.modalDataSubject.next(data);
  }

  hide() {
    this.isModalVisibleSubject.next(false);
    this.modalDataSubject.next(null);
  }
}
